import { render, staticRenderFns } from "./salaires.vue?vue&type=template&id=4268de73&"
import script from "./salaires.vue?vue&type=script&lang=js&"
export * from "./salaires.vue?vue&type=script&lang=js&"
import style0 from "./salaires.vue?vue&type=style&index=0&id=4268de73&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports